/**
* cookie 操作函数
* @param set : 设置cookie
* @param get : 获取cookie
* @param clear : 清除cookie
*/
window['cookieFn'] = {
    //名字，值，日期，地址，域名 ,expires参数要自己定义 -> var myDate = expires=new Date(new Date().getTime() + 1000 * 3600 * 24 * 1);
    set:function(name,value,expires,path,domain)
    {
        //如果默认不填写时间的话，那么就是365天
        if(typeof expires=="undefined")
        {   
            //1000 * 3600 * 24 * 365(天数)
            expires=new Date(new Date().getTime()+1000*3600*24*365);
        }
        document.cookie=name+"="+escape(value)+((expires)?"; expires="+expires.toGMTString():"")+((path)?"; path="+path:"; path=/")+((domain)?";domain="+domain:"");
    },
    //获取cookie值
    get:function(name)
    {
        var arr = document.cookie.match(new RegExp("(^| )"+name+"=([^;]*)(;|$)"));
        if(arr != null)
        {
            return unescape(arr[2]);
        }
        return null;
    },
    //删除指定cookie
    clear:function(name,path,domain)
    {
        if(this.get(name))
        {
        document.cookie=name+"="+((path)?"; path="+path:"; path=/")+((domain)?"; domain="+domain:"")+";expires=Fri, 02-Jan-1970 00:00:00 GMT";
        }
    }
}

window['activityJs'] = function( myElement , hasMsg , pageUrl ){
    var reqAnimationFrame = (function () {
        return window[Hammer.prefixed(window, 'requestAnimationFrame')] || function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };
    })();
    var el = document.querySelector( myElement );
    if ( !el ) return;
    el.style.display = 'block';
    var clientWith = window.innerWidth;
    var clientHeight = window.innerHeight;
    var clientX = Math.round((clientWith - el.offsetWidth) / 2);
    var clientY = Math.round((clientHeight - el.offsetHeight) / 6);
    var START_X = clientX * 2;
    var START_Y = clientY;
    var ticking = false;
    var style = null;
    var transform;
    var timer;
    var mc = new Hammer.Manager(el);
    mc.add(new Hammer.Pan({ threshold: 0, pointers: 0 }));
    mc.add(new Hammer.Tap());
    mc.on("panstart panmove", onPan);
    $(myElement + ' .msg-content').attr('data-url' , pageUrl )
    $(myElement + ' .mui-msg-icon').on('click',onTap)
    $(myElement + ' .mui-msg-in').on('touchstart',function(){
        if ( hasMsg ) {
            var ishttps = 'https:' == document.location.protocol ? 'https://': 'http://';
            var host = window.location.host;
            var dataUrl = $(this).find('a').attr('data-url');
            if(dataUrl.indexOf('javascript') < 0) { window.location.href = ishttps + host + dataUrl; }
        }else{
            window.location.href = 'http://sjjz.udesk.cn/im_client/?web_plugin_id=23638';
        }
    })

    var iconEl = $(myElement + ' .mui-msg-icon')[0];
    var iconElStart = function(){
        iconEl.className = 'mui-active-down mui-msg-icon';
    }
    iconEl.addEventListener('touchstart' , iconElStart)
    
    var iconElEnd = function(){
        var t1 = setTimeout(function(){
            iconEl.className = 'mui-msg-icon';
            clearTimeout(t1)

            //判断是否是展开状态
            t3 && clearTimeout(t3)
            var t3 = setTimeout(function(){
                if ( $(myElement + ' .mui-msg-wrap').css('display') == 'none' ) {
                    $(myElement + ' .mui-msg-icon').css('opacity',0.8)
                }
                clearTimeout(t3)
            },2000)
        },300)
    }
    iconEl.addEventListener('touchend',iconElEnd)

    el.addEventListener('touchmove',function(){
        $(myElement + ' .mui-msg-wrap').hide();
        $(myElement + ' .mui-msg-icon').css('opacity',1)
        el.setAttribute('data-view','hidden')
    })

    mc.on("hammer.input", function(ev) {
        if(ev.isFinal) {
            style = getStyle();
            START_X = (+style[style.length - 2])
            START_Y = (+style[style.length - 1]);
            if(START_Y < 0) START_Y = 0;
            if(START_Y > clientHeight - el.offsetWidth) START_Y = clientHeight - el.offsetWidth;
            START_X = START_X > clientX ? clientWith - el.offsetWidth : 0;
            resetElement();
        }
    });
    function getStyle (){
       return mui.getStyles(el,'transform','webkitTransform').replace(/[^0-9\-,]/g,'').split(',');
    }
    function resetElement() {
        el.className = 'mui-animate';
        transform = {
            translate: { x: START_X, y: START_Y }
        };
        requestElementUpdate();
        // el.style.opacity = 1;
    }
    //停靠 x , y 坐标
    function judgeDirection(x,y){
        if ( x == 0 ) {
            el.className = 'mui-activeity-left'
        }else{
            el.className = 'mui-activeity-right'
        }
    }
    

    function updateElementTransform() {
        var value = ['translate3d(' + transform.translate.x + 'px, ' + transform.translate.y + 'px, 0)']
        value = value.join(" ");
        el.style.webkitTransform = value;
        el.style.mozTransform = value;
        el.style.transform = value;
        ticking = false;
        judgeDirection( transform.translate.x , transform.translate.y )
    }
    function requestElementUpdate() {
        if(!ticking) {
            reqAnimationFrame(updateElementTransform);
            ticking = true;
        }
    }

    function onPan(ev) {
        el.className = '';
        transform.translate = {
            x: START_X + ev.deltaX,
            y: START_Y + ev.deltaY
        }
        requestElementUpdate();
    }

    var autoShow = true;
    function onTap() {
        autoShow = false;
        //假如没有autoShow 这个开关，那么就应该进行判断，并且在user这个页面
        if ( !cookieFn.get('autoShow') && window.location.href.indexOf('#!/user') != -1 ) {
            //定时为一天
            cookieFn.set('autoShow','false', new Date(new Date().getTime() + 1000 * 3600 * 24 * 1) );
        }

        timer && clearTimeout(timer);
        $(myElement + ' .mui-msg-wrap').show();
        timer = setTimeout(function(){
            $(myElement + ' .mui-msg-icon').css('opacity',1)
            if ( el.getAttribute('data-view') == 'hidden' ) {
                el.setAttribute('data-view','show')
                var t1 = setTimeout(function(){
                    //外边相同宽高
                    $(myElement + ' .mui-msg-wrap').css({
                        width: $(myElement + ' .mui-msg').width() +'px',
                        height: $(myElement + ' .mui-msg').height() +'px'
                    })
                    $(myElement + ' .mui-msg-wrap').css({
                        width: $(myElement + ' .mui-msg').width() +'px',
                        height: $(myElement + ' .mui-msg').height() +'px'
                    })
                    //如果靠左要判断文字长短来进行左对齐或者右对齐
                    if( $(myElement).hasClass('mui-activeity-left') ){
                        if( $(myElement + ' .msg-content').width() + 15 < $('.mui-msg-in').width() ){
                            $(myElement + ' .mui-msg-in').css('text-align','right')
                        }else{
                            $(myElement + ' .mui-msg-in').css('text-align','left')
                        }
                    }else{
                        $(myElement + ' .mui-msg-in').css('text-align','left')
                    }
                    clearTimeout(t1)
                })
            }else{
                el.setAttribute('data-view','hidden')
                var timer2 = setTimeout(function(){
                    $(myElement + ' .mui-msg-wrap').hide();
                    clearTimeout(timer2)
                },300)

                if ( el.getAttribute('data-view') == 'hidden' ) {
                    t3 && clearTimeout(t3)
                    var t3 = setTimeout(function(){
                        if ( $(myElement + ' .mui-msg-wrap').css('display') == 'none' ) {
                            $(myElement + ' .mui-msg-icon').css('opacity',0.8)
                        }
                        clearTimeout(t3)
                    },2000)
                }
            }
        },300);
    }

    //如果有新的信息，那么就需要弹出
    if ( hasMsg ) {

        $(myElement + ' .msg-content').html( hasMsg || '您暂时没有新的消息' );
        
        //有新的信息气泡状态
        // onTap();
        // iconElStart();
        // iconElEnd();
        // 延迟弹出
        var t5 = setTimeout(function(){
            //弹出条件：autoShow->用户是否在这段时间内已经点击过,并且时间超过一天才会再次弹出
            if ( autoShow && !cookieFn.get('autoShow') ) {
                onTap();
                iconElStart();
                iconElEnd();
                clearTimeout(t5)
            }
        },3000)
    }else{
        $(myElement + ' .msg-content').html( '点我进入客服中心，小T为您在线服务' );
    }

    resetElement();
}


// WEBPACK FOOTER //
// ./static/js/mui.activeity.js